import axios from "axios";
import { endSession } from "./session";

export const url = process.env.REACT_APP_API_URL;
// export const url = "http://127.0.0.1:5000";

// Create axios instance
const instance = axios.create({
  baseURL: url,
});

// Attach JWT token to every request and inject project_id when available
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const projectId = localStorage.getItem("projectId");
    if (projectId) {
      const method = config.method?.toLowerCase();
      if (method === "get" || method === "delete") {
        // Inject as query parameter for GET-like requests
        config.params = { ...config.params, project_id: projectId };
      } else if (method === "post" || method === "put") {
        if (config.data instanceof FormData) {
          // Inject into FormData for file uploads
          config.data.append("project_id", projectId);
        } else if (config.data && typeof config.data === "object") {
          // Inject into JSON body
          config.data = { ...config.data, project_id: projectId };
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Global response interceptor: handle 401 Unauthorized
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect/logout on a failed login request so
      // the LoginPage can display the error messages
      if (error.config?.url !== "/auth/login") {
        // ProtectedRoute sends the user to /login once logged out.
        endSession();
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
